import React from 'react';
import logo from '../images/android-chrome-512x512.png';
function Logo () {
    return (
        <div className='App Logo'>
            <a href='/'>
            <img src={logo} alt='logo' />
            </a>
        </div>
    );
}

export default Logo;